<template>
    <div>
    
        <div class="jumbotron text-center">
            <h3>{{ titulo }}</h3>
            <br><br>
            
            <div v-if="isInitializing">
                <br>
                <div style="text-align:center">Estamos validando la dirección de tu correo electrónico...</div><br>
                <div style = "margin:0px 48%!important" class="loading" >
                    <RotateSquare3 :size="90"></RotateSquare3>
                </div>
            </div>

            <div v-else-if="showNotFound" class="row animated fadeIn">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="text-center">
                    <h4>❌ Tu dirección de correo electrónico no se ha podido confirmar.</h4>
                    <p>Intenta consultando tus datos y re-enviando el correo de validación nuevamente.</p>
                    <button @click.prevent="sendEmail()" class="btn btn-primary waves-effect">Volver a consultar mis datos</button>
                    </div>
                </div>
            </div>

            <div v-else-if="showSelectDecision" class="row animated fadeIn">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="text-center">
                    <h4>Ahora, necesitamos que nos confirmes la decisión de utilizar la dirección de correo electrónico registrada.</h4>
                    <div class="decision-container mt-4">
                        <button @click.prevent="confirmEmail(true)" class="btn btn-success waves-effect btn-decision">Sí, quiero utilizar este correo</button>
                        <button @click.prevent="confirmEmail(false)" class="btn btn-danger waves-effect btn-decision">No quiero utilizar este correo</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    
    </template>
    
    <script>
    import { HTTP_GURU_BACKEND, swal } from '../../share.js';
    import { RotateSquare3 } from 'vue-loading-spinner';
    
    export default {
        data() {
            return {
                titulo: 'Validación de dirección de correo electrónico para voto a distancia',
                isInitializing : true,
                showNotFound : false,
                showSelectDecision : false,
            }
        },
        props: ["token","electors_id"],
        components: {
            RotateSquare3,
        },
        created() {
        },
        mounted() {
            if (this.token) {
                this.getData();
            } else {
                this.showNotFound = true;
                this.isInitializing = false;
            }
        },  
        methods: {
            getData(){
                let self = this;
                HTTP_GURU_BACKEND.get(`email-validation-tokens/${this.token}`)
                .then(response => {
                    self.isInitializing = false;
                    self.showSelectDecision = true;
                })
                .catch((error) => {
                    let status = error.response.status;
                    self.isInitializing = false;
                    self.showNotFound = true;

                    switch (status) {
                        case 500:
                            swal({
                                title: "Algo salió mal",
                                text: "Ha sucedido algo inesperado. Intenta nuevamente y si persigue el inconveniente contácte con tu Facultad.",
                                type: "warning"
                            })
                            break;
                    }
                })
                .finally(() => {
                });
            },
            sendEmail(){
                this.$router.push('/consultas');
            },
            confirmEmail(decision){
                let self = this;
               
                swal({
                    title: '¿Quieres continuar?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No'
                })
                .then((result) => {
                    if (result) { 

                        let bodyToSend = {
                            is_valid : decision
                        }

                        HTTP_GURU_BACKEND.patch(`email-validation-tokens/${this.token}`,bodyToSend)
                        .then(response => {
                            this.isInitializing = false;
                            this.showSelectDecision = true;

                            if(decision){
                                swal({
                                    title: 'Dirección de correo electrónico confirmada',
                                    text: 'Has confirmado la utilización de esta dirección de correo electrónico.',
                                    type: 'success'
                                }).then(()=>{
                                    this.$router.push('/consultas');
                                })
                            }else{
                                swal({
                                    title: 'Dirección de correo electrónico no confirmada',
                                    text: 'Has optado por no confirmar la dirección de correo electrónico registrada. Si deseas cambiar la decisión o consideras que ha sido un error, comunícate con tu Facultad.',
                                    type: 'info'
                                }).then(()=>{
                                    this.$router.push('/consultas');
                                })
                            }
                        })
                        .catch((error) => {
                            this.isInitializing = false;
                            swal({
                                    title: 'Algo salió mal',
                                    text: 'Ha ocurrido un inconveniente al registrar tu decisión. Si el problema continua, intenta enviarte nuevamente el correo electrónico o comunícate con tu Facultad.',
                                    type: 'error'
                                }).then(()=>{
                                    this.$router.push('/consultas');
                                })
                        })
                        .finally(() => {
                        });   
                    }
                }).catch(()=>{})
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
        .decision-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
            
            @media (min-width: 576px) {
                flex-direction: row;
            }
        }

        .btn-decision {
            padding-left: 1.5rem !important;
            padding-right: 1.5rem !important;
            width: 100%;

            @media (min-width: 576px) {
                width: auto;
                margin-bottom: 0 !important;
            }
        }
    </style>